import type { CultureTargetGroupDTO } from '@ui/shared/util-api';
import { TargetGroupModel } from '../entities/target-group.model';

export class CulturalTargetGroupMapper {
    public static fromDto(dto: CultureTargetGroupDTO): TargetGroupModel {
        return new TargetGroupModel({
            id: dto.id,
            label: dto.name,
        });
    }
}
